type ChartLike = {
  series: Array<{ visible: boolean; setVisible: (visible: boolean, redraw: boolean) => void }>
  redraw: () => void
  _savedSeriesState?: boolean[]
}

export function saveFullscreenSeriesState(chart: ChartLike): void {
  chart._savedSeriesState = chart.series.map(s => s.visible)
}

export function restoreFullscreenSeriesState(chart: ChartLike): void {
  if (!chart._savedSeriesState) return
  chart.series.forEach((s, i) => {
    if (i < chart._savedSeriesState!.length && s.visible !== chart._savedSeriesState![i]) {
      s.setVisible(chart._savedSeriesState![i], false)
    }
  })
  chart.redraw()
  delete chart._savedSeriesState
}
